<style src="./Error.scss" lang="scss" scoped></style>
<script src="./Error.js"></script>

<template>
	<div class="app-wrapper content-error">Error 404</div>
</template>
